import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { likeComment } from '@utils/backend-api/comments';
import { CURRENT_USER_KEY } from '@utils/backend-api/currentUser';

export default function useCommentLike(onSuccess: () => void) {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError } = useMutation((id: number) => likeComment(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(CURRENT_USER_KEY);
      onSuccess();
    },
    onError: () => {
      toast.error('Comment like failed, please try again');
    },
  });

  return { mutate, isLoading, isError };
}
